import * as React from 'react';

import { Divider } from '@coursera/coursera-ui';

import AppleAlternative from 'bundles/authentication/shared/components/third-party-auth/AppleAlternative';
import FacebookAlternative from 'bundles/authentication/shared/components/third-party-auth/FacebookAlternative';
import GoogleAlternative from 'bundles/authentication/shared/components/third-party-auth/GoogleAlternative';
import { MODES } from 'bundles/authentication/shared/components/third-party-auth/constants';

import _t from 'i18n!nls/authentication';

type Props = {
  showGoogle?: boolean;
  showFacebook?: boolean;
  showApple?: boolean;
  authProvider?: string;
  onSuccess: (response?: unknown) => void;
  mode?: MODES;
};

const ThirdPartyAuthButtons = ({ showGoogle, showFacebook, showApple, onSuccess, authProvider, mode }: Props) => {
  const atLeastOneButtonIsShown = showGoogle || showFacebook || showApple;

  if (authProvider || !atLeastOneButtonIsShown) {
    return null;
  }

  let dividerText = _t('or');

  if (mode === MODES.SIGNUP) {
    dividerText = _t('or sign up with email');
  } else if (mode === MODES.LOGIN) {
    dividerText = _t('or log in with email');
  }

  return (
    <div className="rc-ThirdPartyAuthButtons">
      {showGoogle && <GoogleAlternative onSuccess={onSuccess} />}
      {showFacebook && <FacebookAlternative onSuccess={onSuccess} />}
      {showApple && <AppleAlternative onSuccess={onSuccess} />}
      <Divider>
        <span className="m-y-1 text-muted" style={{ fontSize: 12 }}>
          {dividerText}
        </span>
      </Divider>
    </div>
  );
};

export default ThirdPartyAuthButtons;
